import { render, staticRenderFns } from "./RejectionAnalysis.vue?vue&type=template&id=650837d4&scoped=true&"
import script from "./RejectionAnalysis.vue?vue&type=script&lang=js&"
export * from "./RejectionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./RejectionAnalysis.vue?vue&type=style&index=0&id=650837d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650837d4",
  null
  
)

export default component.exports